@if (userQueries.authenticatedUser$ | async; as authenticatedUser) {
  <e-dropdown-menu
    #menu
    position="left"
    >
    <ng-template eSlot="activator">
      <button
        class="user-trigger"
        (click)="menu.toggleMenu()"
        [title]="authenticatedUser.displayName"
        >
        <span class="user-trigger__avatar"><span class="avatar-initials">{{ getInitials(authenticatedUser) }}</span></span>
      </button>
    </ng-template>
    <ng-template eSlot="menu">
      <div class="user-menu-panel" (click)="$event.stopPropagation()">
        <div class="user-menu-panel__header">
          <div class="user-menu-panel__avatar"><span class="avatar-initials">{{ getInitials(authenticatedUser) }}</span></div>
          <div class="user-menu-panel__identity">
            <div class="user-menu-panel__name">{{ authenticatedUser.displayName }}</div>
          </div>
        </div>
        <div class="user-menu-panel__divider"></div>
        <button
          type="button"
          class="user-menu-panel__item"
          (click)="userSettingsDialogOpened = true; menu.toggleMenu(false)"
          >
          <i eIcon icon="cog" class="user-menu-panel__item-icon"></i>
          <span>{{ 'account.userMenu.settings' | transloco }}</span>
        </button>
        @if (isAppSettingsAvailable()) {
          <button
            type="button"
            class="user-menu-panel__item"
            (click)="openAppSettings(); menu.toggleMenu(false)"
            >
            <i eIcon icon="sliders" class="user-menu-panel__item-icon"></i>
            <span>{{ 'account.userMenu.appSettings' | transloco }}</span>
          </button>
        }
        @if (platformBeheerApp$ | async; as platformBeheerApp) {
          <div class="user-menu-panel__divider"></div>
          <button
            type="button"
            class="user-menu-panel__item"
            (click)="navigateToPlatformBeheer(platformBeheerApp); menu.toggleMenu(false)"
            >
            @if (platformBeheerIcon; as platformBeheerIconName) {
              <i
                eIcon
                [icon]="platformBeheerIconName"
                class="user-menu-panel__item-icon"
              ></i>
            }
            <span>{{ 'account.userMenu.platformAdmin' | transloco }}</span>
          </button>
        }
        <div class="user-menu-panel__divider"></div>
        <button
          type="button"
          class="user-menu-panel__item"
          (click)="onLogout(); menu.toggleMenu(false)"
          >
          <i eIcon icon="sign-out-alt" class="user-menu-panel__item-icon"></i>
          <span>{{ 'account.userMenu.logout' | transloco }}</span>
        </button>
      </div>
    </ng-template>
  </e-dropdown-menu>
}

<e-dialog
  [(open)]="userSettingsDialogOpened"
  [title]="'account.userMenu.infoTitle' | transloco: { name: (displayName$ | async) }"
  size="lg"
  >
  <ng-template>
    <user-settings-container style="height: 500px"></user-settings-container>
  </ng-template>
</e-dialog>
